module.exports = __webpack_public_path__ + "img/img-kepple.211b6242.jpg";